var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2757 14.7277L18.0942 14.7277L18.0942 22.0909L27.8321 22.0909C26.2721 27 22.4322 28.6368 18.0162 28.6368C13.314 28.643 9.1657 25.561 7.81424 21.0572C6.46279 16.5534 8.22891 11.6966 12.1577 9.11294C16.0864 6.52925 21.2455 6.83178 24.8454 9.85696L30.1961 4.76059C24.2698 -0.698073 15.4378 -1.55346 8.57404 2.66648C1.71032 6.88641 -1.51298 15.1536 0.682939 22.9058C2.87885 30.658 9.959 36.0066 18.0162 36C27.9413 36 36.9125 29.454 35.2757 14.7277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.b984d7e595430792ad0fc016897fcaf2.svg";
export { ForwardRef as ReactComponent };